import styled, { keyframes } from 'styled-components';

import { media } from '../../utils/mediaQueries';

const slideInBottom = keyframes`
    from {
        transform: translateY(100%);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
`;

const slideOutBottom = keyframes`
    from {
        transform: translateY(0);
        opacity: 1;
    }
    to {
        transform: translateY(100%);
        opacity: 0;
    }
`;

const slideInTop = keyframes`
    from {
        transform: translateY(-100%);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
`;

const slideOutTop = keyframes`
    from {
        transform: translateY(0);
        opacity: 1;
    }
    to {
        transform: translateY(-100%);
        opacity: 0;
    }
`;

export const ActionBannerWrapper = styled.div<{ $isClosing?: boolean }>`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    box-sizing: border-box;
    background-color: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
    box-shadow: ${({ theme }) => (theme.mode === 'dark' ? '0 -4px 12px rgba(0, 0, 0, 0.3)' : '0 -4px 12px rgba(0, 0, 0, 0.08)')};
    padding: 12px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    border-top: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
    animation: ${(props) => (props.$isClosing ? slideOutBottom : slideInBottom)} 0.3s ease-out forwards;

    ${media.tabletDown} {
        top: 0;
        bottom: auto;
        left: 0;
        right: 0;
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
        padding: 12px 16px;
        border-top: none;
        border-bottom: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
        box-shadow: ${({ theme }) => (theme.mode === 'dark' ? '0 4px 12px rgba(0, 0, 0, 0.3)' : '0 4px 12px rgba(0, 0, 0, 0.08)')};
        animation: ${(props) => (props.$isClosing ? slideOutTop : slideInTop)} 0.3s ease-out forwards;
    }
`;

export const ActionBannerHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;

  ${media.tabletDown} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const ActionBannerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;

  ${media.tabletDown} {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f3f4f6')};
    color: ${({ theme }) => (theme.mode === 'dark' ? '#f8fafc' : '#1a1d1f')};
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const Title = styled.h3`
  font-weight: 300;
  font-size: 14px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f8fafc' : '#1a1d1f')};
  margin: 0;
  line-height: 1.3;
  white-space: nowrap;

  ${media.tabletDown} {
    font-size: 15px;
  }
`;

export const Description = styled.p`
  font-weight: 400;
  font-size: 13px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#707a82')};
  margin: 0;
  line-height: 1.3;

  ${media.tabletDown} {
    font-size: 13px;
  }
`;

export const ImageWrapper = styled.div`
  display: none;
`;

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  ${media.tabletDown} {
    width: 100%;

    button {
      width: 100%;
      justify-content: center;
    }
  }
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  white-space: nowrap;
  min-height: 30px;
  background: #111827;
  color: #ffffff;
  border: 1px solid transparent;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease;

  &:hover:not(:disabled) {
    background: #000000;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.28);
  }

  &:active:not(:disabled) {
    transform: scale(0.97);
  }

  &:disabled {
    background: #9ca3af;
    opacity: 0.6;
    cursor: not-allowed;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
    transform: none;
  }

  ${({ theme }) => (theme.mode === 'dark'
    ? `
    background: #1f2937;
    border-color: #374151;

    &:hover:not(:disabled) {
      background: #111827;
    }
  `
    : '')}
`;
